import { Button, Card, CardBody, DrawerBody, DrawerFooter, Stack, Text, useToast } from '@chakra-ui/react';
import { prettyDate } from '@pelicargo/utils';
import { ShipmentEvent } from '@prisma/client';
import { useState } from 'react';

import { trpc } from '../../../config/trpc';
import { useTrackingInfo } from '../../../context/TrackingInfo';
import { LabeledText } from '../../LabeledText';

export const EventsTab = () => {
  const toast = useToast();
  const { request, refetchRequest } = useTrackingInfo();

  const { mutateAsync: updateEvents } = trpc.updateShipmentEvents.useMutation();

  const [isRefetching, setIsRefetching] = useState(false);

  const renderEvent = (event: ShipmentEvent) => {
    return (
      <Card key={event?.id} w="full">
        <CardBody>
          <Stack>
            <Text textStyle="label">{event?.raw_type}</Text>
            <Stack direction="row" spacing="8" wrap="wrap">
              <LabeledText label="Occurred At" value={prettyDate(event?.occurred_at)} />
              <LabeledText label="Flight #" value={event?.flight_number} />
              <LabeledText label="Weight" value={event?.weight} />
              <LabeledText label="Piece Count" value={event?.piece_count} />
            </Stack>
          </Stack>
        </CardBody>
      </Card>
    );
  };

  const renderEvents = (shipment: (typeof request)['tracking_shipments'][0]) => {
    return (
      <Stack>
        <Text fontSize="xl" fontWeight="bold">
          {shipment.tracking_number}
        </Text>
        {shipment.events.map(renderEvent)}
      </Stack>
    );
  };

  const handleRefresh = async () => {
    try {
      setIsRefetching(true);
      await updateEvents({
        request_id: request.id,
      });
      await refetchRequest();
      setIsRefetching(false);
      toast({ title: 'Events refreshed', status: 'success' });
    } catch (error) {
      setIsRefetching(false);
      toast({
        title: 'Something went wrong',
        description: error.message,
        status: 'error',
      });
    }
  };

  return (
    <>
      <DrawerBody>
        <Stack spacing="4">
          <Stack w="full">{request?.tracking_shipments?.map(renderEvents)}</Stack>
        </Stack>
      </DrawerBody>
      <DrawerFooter borderTopWidth="1px">
        <Button isLoading={isRefetching} onClick={handleRefresh}>
          Refresh
        </Button>
      </DrawerFooter>
    </>
  );
};
